import {
  POSTFORM,
  GET,
  PUT,
  DELETE,
  POST,
  API_GRANT_PASSWORD,
  API_CLIENT_ID,
  API_CLIENT_SECRET
} from '../http'
import * as Types from './types'
import * as Utils from '../../modules/Utils'

export default class AuthGateway {
  login (query = {}) {
    return POSTFORM(Types.LOGIN_END_POINT, Utils.encodeParams({
      client_id: API_CLIENT_ID,
      grant_type: API_GRANT_PASSWORD,
      client_secret: API_CLIENT_SECRET,
      ...query
    }))
  }

  userInfo () {
    return GET(Types.USER_INFO_END_POINT)
  }

  getAccounts () {
    return GET(Types.ACCOUNT_ALL_END_POINT)
  }

  syncAccounts () {
    return GET(Types.ACCOUNT_SYNC)
  }

  getRoles () {
    return GET(Types.ACCOUNT_ROLES_END_POINT)
  }

  setPassword (query = {}) {
    return POST(Types.ACCOUNT_SET_PASSWORD_END_POINT, query)
  }

  createAccount (query = {}) {
    return POST(Types.ACCOUNT_CREATE_END_POINT, query)
  }

  setEmail (query = {}) {
    return POST(Types.ACCOUNT_SET_EMAIL_END_POINT, query)
  }

  assignRole (query = {}) {
    return POST(Types.ACCOUNT_ASSIGN_ROLE_END_POINT, query)
  }

  unassignRole (query = {}) {
    return POST(Types.ACCOUNT_UNASSIGN_ROLE_END_POINT, query)
  }

  updateAccount (query = {}) {
    return PUT(Types.ACCOUNT_UPDATE, query)
  }

  deleteAccount (query = {}) {
    return DELETE(Types.ACCOUNT_DELETE_END_POINT, {}, query)
  }
}



// WEBPACK FOOTER //
// ./src/api/auth/AuthGateway.js